import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";

const Waivers = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>The Winchester Porchfest Liability Waivers</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h5><strong>PERFORMER ACCIDENT WAIVER AND RELEASE OF LIABILITY FORM</strong></h5>
                        <p>
                            By signing up to perform, the performer, on behalf of his/her band or group, agrees to hold
                            Winchester Porchfest and each of its directors, officers, volunteers, and agents harmless
                            for any liability arising out of any and all acts or injuries to the performer, members of
                            his/her band/group and personal property of the performer and members of his/her band/group
                            arising out of this agreement.
                        </p>
                        <p>
                            In consideration of my application and permitting me to participate in Winchester Porchfest
                            and on behalf of my band or group, I/we hereby take action for myself/ourselves, my/our
                            executors, administrators, heirs, next of kin, successors, and assigns as follows:
                        </p>
                        <p>
                            (A) I/WE WAIVE, RELEASE, AND DISCHARGE from any and all liability, including but not limited
                            to, liability arising from the negligence or fault of the event organizers or volunteers,
                            any claims or damages for my/our death, disability, personal injury, property damage,
                            property theft, or actions of any kind which may hereafter occur to me including my/our
                            traveling to and from this activity, THE FOLLOWING ENTITIES OR PERSONS: the Town of
                            Winchester, the Town’s directors, officers, employees, volunteers, representatives, and
                            agents, and the activity holders, organizers, sponsors, and volunteers;
                        </p>
                        <p>
                            (B) I/WE INDEMNIFY, HOLD HARMLESS, AND PROMISE NOT TO SUE the entities or persons mentioned
                            in this Release from any and all liabilities or claims made as a result of participation in
                            this activity, whether caused by the negligence or fault of the organizers and/or the Town
                            of Winchester.
                        </p>
                        <p>
                            I/We acknowledge that the Town of Winchester and their directors, officers, volunteers,
                            representatives, and agents and the activity holders, organizers, sponsors, and volunteers,
                            are NOT responsible for the errors, omissions, acts, or failures to act of any third party
                            or entity conducting a specific activity at or during the Event.
                        </p>
                        <p>
                            I/We understand while participating in this activity, I/we may be photographed or filmed.
                            I/We agree to allow my/our photo, video, or film likeness to be used for any legitimate
                            purpose by the Town of Winchester, the Event organizers, and their successors and/or
                            assigns.
                        </p>
                        <p>
                            The Accident Waiver and Release of Liability Form shall be construed broadly to provide a
                            release and waiver to the maximum extent permissible under applicable law.
                        </p>
                        <p>
                            I/we, acknowledge and agree that my/our contact information (telephone numbers, email
                            addresses, physical addresses) may be distributed and released in order to coordinate
                            Porchfest activities. I/we also acknowledge and agree that my/our photographs, audio-only
                            tracks, audiovisual images, recordings of performances, website and links may be distributed
                            and released in order to coordinate Porchfest activities and for promoting Porchfest.
                        </p>
                        <p>
                            I/WE CERTIFY THAT I/WE HAVE READ THIS DOCUMENT AND I/WE FULLY UNDERSTAND ITS CONTENT. I
                            AM/WE ARE AWARE THAT THIS DOCUMENT IS A RELEASE OF LIABILITY AND A CONTRACT AND I/WE AGREE
                            TO IT OF MY/OUR OWN FREE WILL.
                        </p>
                        <br/>

                        <h5><strong>HOST ACCIDENT WAIVER AND RELEASE OF LIABILITY FORM</strong></h5>
                        <p>
                            By signing up to host, the homeowner, on behalf of himself/herself, members of his/her
                            household, and any tenant(s) leasing the property, agrees to hold Winchester Porchfest and
                            each of its directors, officers, volunteers, and agents harmless for any liability arising
                            out of any and all acts or injuries to the homeowner, members of his/her household, tenants,
                            and his/her real property arising out of this agreement.
                        </p>
                        <p>
                            In consideration of my application and permitting me to participate in this activity, I/we
                            hereby take action for myself/ourselves, my/our executors, administrators, heirs, next of
                            kin, successors, and assigns as follows:
                        </p>
                        <p>
                            (A) I/WE WAIVE, RELEASE, AND DISCHARGE from any and all liability, including, but not
                            limited to, liability arising from the negligence or fault of the event organizers or
                            volunteers,
                            all claims and damages for my/our death, disability, personal injury, property damage,
                            property theft, or actions of any kind which may hereafter occur to me including my/our
                            traveling to and from this activity, THE FOLLOWING ENTITIES OR PERSONS: the Town of
                            Winchester and/or the
                            Town’s directors, officers, employees, volunteers, representatives, and agents, and the
                            activity holders, organizers, sponsors, and volunteers;
                        </p>
                        <p>
                            (B) I/WW INDEMNIFY, HOLD HARMLESS, AND PROMISE NOT TO SUE the entities or persons mentioned
                            in this Release from any and all liabilities or claims made as a result of participation in
                            this Event, whether caused by the negligence or fault of the Town of Winchester.
                        </p>
                        <p>
                            I/We acknowledge that the Town of Winchester and the Town’s directors, officers, volunteers,
                            representatives, and agents and the activity holders, organizers, sponsors, and volunteers,
                            are NOT responsible for the errors, omissions, acts, or failures to act of any third party
                            or entity conducting a specific activity at or during the Event.
                        </p>
                        <p>
                            I/We understand while participating in the Event, I/we may be photographed or filmed. I/We
                            agree to allow my/our photo, video, or film likeness to be used for any legitimate purpose
                            by the Town of Winchester, the Event organizers, and their successors and/or assigns.
                        </p>
                        <p>
                            The Accident Waiver and Release of Liability Form shall be construed broadly to provide a
                            release and waiver to the maximum extent permissible under applicable law.
                        </p>
                        <p>
                            I/we, the participating homeowner, acknowledge and agree that my/our contact information
                            (telephone numbers, email addresses, physical addresses) may be distributed and released in
                            order to coordinate porchfest activities.
                        </p>
                        <p>
                            I/WE CERTIFY THAT I/WE HAVE READ THIS DOCUMENT AND I/WE FULLY UNDERSTAND ITS CONTENT. I
                            AM/WE ARE AWARE THAT THIS DOCUMENT IS A RELEASE OF LIABILITY AND A CONTRACT AND I/WE AGREE
                            TO IT OF MY/OUR OWN FREE WILL.
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Waivers;
